import {
  LifetimeSlug, Membership, MembershipSlug,
  Student, PageKind
} from '@upskillist/gatsby-theme-learner-portal/src/index';
import botpressConfig from '../../data/botpress/webchat/config.json';
import linaBotConfig from '../../data/botpress/lina/config.json';
import supportBotConfig from '../../data/botpress/support/config.json';

export enum AddonsStatus {
  TOOLKIT = 'paid',
  ECERT = 'paid',
  HCD = 'paid'
};
export enum AddonsStatusForLifetimeUnlimited {
  TOOLKIT='free',
  ECERT='free',
  HCD='paid'
}
export enum AddonsStatusForLifetimeFaculty {
  TOOLKIT='free',
  ECERT='free',
  HCD='paid'
}

export enum AddonsStatusForLifetimeBasic {
  TOOLKIT='free',
  ECERT='paid',
  HCD='paid'
}

export const TOOLKIT_PAID_COUNTRIES = ['us', 'gb', 'au'];

export enum OfferType {
  defaultOfferType = 'CC7',
  skip = 'SKIP',
  skip2 = 'SKIP2',
  skip3 = 'SKIP3',
  skip6 = 'SKIP6',
  prepay70 = 'PREPAY-70',
  prepay75 = 'PREPAY-75',
  prepay80 = 'PREPAY-80',
  prepay90 = 'PREPAY-90',
  prepay = 'PREPAY',
  cc = 'CC',
  cc7 = 'CC7',
  cc14 = 'CC14',
  cc60 = 'CC60',
  gift1m = 'GIFT-1M',
  gift3m = 'GIFT-3M',
  gift6m = 'GIFT-6M',
  gift12m = 'GIFT-12M',
  ltbasic = 'LT-BASIC'
};

export const getDefaultOfferType = (
    countryCode = '', courseSlug = '', partnerIdentifier = '',
) => {
  if (['in', 'ng','ph'].includes(countryCode)) {
    return OfferType.skip3;
  }
  return OfferType.defaultOfferType;
};

export enum ReferralCode {
  ENABLE = 0,
};

export const autoPopupInContentPage = true;

export const skipPhoneInputFormEligibleCountries = ['in', 'ng', 'ph','de','br','fr'];

export const rebrandDesignEligibleCountries = ['in', 'ca', 'ph', 'za'];

export const shouldShowCCPage = (offerType: string) => {
  if (offerType.indexOf('GIFT') === 0) {
    return false;
  }
  return true;
// const eligibleOffers = ['CC', 'SKIP'];
// return eligibleOffers.includes(offerType);
};

const enableTrialInformationPage = true;

export const shouldShowTrialInfoPage = (
    offerType: string, countryCode: string, courseSlug: string,
) => {
  if (enableTrialInformationPage) {
    if (['CC', 'CC7', 'CC14', 'SKIP'].includes(offerType)) {
      return true;
    }
    return false;
  }
  return false;
};

export const getOfferTrialDays = (offerType: string) => {
// TODO: Verify
  let offerTrialDays = 28;
  if (offerType === 'GIFT-1M') {
    offerTrialDays = 30;
  } else if (offerType === 'GIFT-3M') {
    offerTrialDays = 90;
  } else if (offerType === 'GIFT-6M') {
    offerTrialDays = 180;
  } else if (offerType === 'GIFT-12M') {
    offerTrialDays = 365;
  } else if (offerType === 'CC7') {
    offerTrialDays = 7;
  } else if (offerType === 'CC14') {
    offerTrialDays = 14;
  } else if (offerType === 'CC60') {
    offerTrialDays = 60;
  } else if (offerType === 'SKIP2') {
    offerTrialDays = 60;
  } else if (offerType === 'SKIP3') {
    offerTrialDays = 90;
  } else if (offerType === 'SKIP6') {
    offerTrialDays = 180;
  }
  return offerTrialDays;
};

export const offerCodeMapping = {
  'JN1M': 'GIFT-1M',
  'JL3M': 'GIFT-3M',
  'AU6M': 'GIFT-6M',
  'SE12M': 'GIFT-12M',
  'SKIP': 'SKIP',
  'SKIP2': 'SKIP2',
  'SKIP3': 'SKIP3',
  'SKIP6': 'SKIP6',
  'CC': 'CC',
  'CC7': 'CC7',
  'CC14': 'CC14',
  'CC60': 'CC60',
  'PREPAY-70': 'PREPAY-70',
  'PREPAY-75': 'PREPAY-75',
  'PREPAY-80': 'PREPAY-80',
  'PREPAY-90': 'PREPAY-90',
  'PREPAY': 'PREPAY',
  'LT-BASIC': 'LT-BASIC',
  'LT-UNLIMITED': 'LT-UNLIMITED',
  'LT-ET': 'LT-ET',
  'LT-EF': 'LT-EF',
  'LT-NY': 'LT-NY',
  'LT-NT': 'LT-NT',
  'LT-NF': 'LT-NF',
  'OCLT': 'GIFT-LT'
};

export const showVideoPreviewOnCoursePage = true;

export const getPaymentLinkVersionPrefix = (
    data: {
      partnerIdentifier?: string, country?: string, membership?: Membership
    },
) => {
  let hasExpiredGiftPremium = false;
  if (
    (data.membership?.slug === MembershipSlug.GIFT_PREMIUM) &&
    data.membership?.end_date &&
    (new Date(data.membership.end_date) < new Date())
  ) {
    hasExpiredGiftPremium = true;
  }
  if (
    (data.partnerIdentifier === 'tmobile') &&
    !hasExpiredGiftPremium
  ) {
    return '/';
  }
  return '/v2/';
};

export const getScheduleVersion = (
  {country, membership}: {country?: string, membership?: Membership},
) => {
  const v2ScheduleCountries: any = ['us','gb', 'in', 'za', 'ng','ph','de','br','fr','gb','au','ca','pr'];
  const lifetimeSlugs: any = Object.values(LifetimeSlug);
  if (v2ScheduleCountries.includes(country)) {
    return 'v2';
  } else if (lifetimeSlugs.includes(membership?.slug)) {
    return 'v2';
  }
  return 'v1';
};

export const COMPASS_AI_COURSES = [
  'ai-content-mastery-24', 'cybersecurity-20', 'ai-growth-24', 'midjourney-24',
  'chatgptpro-24', 'prompt-24', 'psychology-20', 'social-media',
  'photography-21', 'excel-20', 'project-management', 'graphic-design',
  'chatgpt-23', 'sound-eng-20', 'share-trading-20', 'leadership-1',
  'artificial-intel-20', 'financial-planning-20', 'seo-marketing',
  'smartphone-photo', 'writing-20', 'ecommerce-21', 'python-23',
  'bookkeeping-20', 'tech-coding-20', 'data-analytics-20', 'start-business',
  'design-budget', 'mba-20', 'screenwriting-21', 'coach-22', 'cooking-baking-20',
  'interior-design-20', 'team-management-22', 'diversity-22', 'hr-22', 'painting-20',
  'photoshop-1', 'tech-drawing-22'
];
export const COMPASS_AI_ENABLED_PAGES = [
  PageKind.COURSE_REG_DETAILS_PAGE,
  PageKind.LESSONS_PAGE, PageKind.RESOURCES_PAGE, PageKind.ASSIGNMENTS_PAGE,
  PageKind.WEBINAR_PAGE,
];
export const LINA_ENABLED_PAGES = [
  PageKind.BROWSE_PAGE,
];
export const SUPPORT_BOT_ENABLED_PAGES = [
  PageKind.HELP_CENTER_PAGE,
];
export const getBotpressConfiguration = (
    {student, pageKind}: { student?: Student | null, pageKind?: PageKind },
) => {
  // Kairo for public
  if (
    student?.attributes.membership.slug === 'premium' &&
    student.attributes.membership.status === 'active' &&
    (COMPASS_AI_ENABLED_PAGES as any).includes(pageKind)
  ) {
    return {
      ...botpressConfig,
      'user': {
        'name': [
          student.attributes.name.first_name, student.attributes.name.last_name,
        ].filter((namePart) => namePart).join(' '),
        'data': {
          'firstName': student.attributes.name.first_name,
          'lastName': student.attributes.name.last_name,
          'student_id': student.id,
          'first_goal': student.attributes.profile.goals,
          'first_course': student.attributes.profile.course_picked,
        },
      },
    };
  }
  if (
    student?.attributes.membership.slug === 'premium' &&
    student.attributes.membership.status === 'in_trial' &&
    (COMPASS_AI_ENABLED_PAGES as any).includes(pageKind)
  ) {
    return {
      ...botpressConfig,
      'user': {
        'name': [
          student.attributes.name.first_name, student.attributes.name.last_name,
        ].filter((namePart) => namePart).join(' '),
        'data': {
          'firstName': student.attributes.name.first_name,
          'lastName': student.attributes.name.last_name,
          'student_id': student.id,
          'first_goal': student.attributes.profile.goals,
          'first_course': student.attributes.profile.course_picked,
        },
      },
    };
  }
  // Kairo for internal
  if (
    (
      student?.attributes.email.endsWith('@upskillist.com') ||
      student?.attributes.email.endsWith('@mailinator.com')
    ) &&
    (COMPASS_AI_ENABLED_PAGES as any).includes(pageKind)
  ) {
    return {
      ...botpressConfig,
      'user': {
        'name': [
          student.attributes.name.first_name, student.attributes.name.last_name,
        ].filter((namePart) => namePart).join(' '),
        'data': {
          'firstName': student.attributes.name.first_name,
          'lastName': student.attributes.name.last_name,
          'student_id': student.id,
          'first_goal': student.attributes.profile.goals,
          'first_course': student.attributes.profile.course_picked,
        },
      },
    };
  }
  // LINA for public
  const lifetimeSlugs: any = Object.values(LifetimeSlug);
  if (
    student?.attributes.membership.slug &&
    (!lifetimeSlugs.includes(student.attributes.membership.slug)) &&
    (LINA_ENABLED_PAGES as any).includes(pageKind)
  ) {
    return {
      ...linaBotConfig,
      'user': {
        'name': [
          student.attributes.name.first_name, student.attributes.name.last_name,
        ].filter((namePart) => namePart).join(' '),
        'data': {
          'firstName': student.attributes.name.first_name,
          'lastName': student.attributes.name.last_name,
          'student_id': student.id,
          'first_goal': student.attributes.profile.goals,
          'first_course': student.attributes.profile.course_picked,
        },
      },
    };
  }
  // LINA for internal
  if (
    (
      student?.attributes.email.endsWith('@upskillist.com') ||
      student?.attributes.email.endsWith('@mailinator.com')
    ) &&
    (LINA_ENABLED_PAGES as any).includes(pageKind)
  ) {
    return {
      ...linaBotConfig,
      'user': {
        'name': [
          student.attributes.name.first_name, student.attributes.name.last_name,
        ].filter((namePart) => namePart).join(' '),
        'data': {
          'firstName': student.attributes.name.first_name,
          'lastName': student.attributes.name.last_name,
          'student_id': student.id,
          'first_goal': student.attributes.profile.goals,
          'first_course': student.attributes.profile.course_picked,
        },
      },
    };
  }
  // Support bot
  if (
    student?.attributes &&
    (SUPPORT_BOT_ENABLED_PAGES as any).includes(pageKind)
  ) {
    return {
      ...supportBotConfig,
      'user': {
        'name': [
          student.attributes.name.first_name, student.attributes.name.last_name,
        ].filter((namePart) => namePart).join(' '),
        'data': {
          'firstName': student.attributes.name.first_name,
          'lastName': student.attributes.name.last_name,
          'student_id': student.id,
          'first_goal': student.attributes.profile.goals,
          'first_course': student.attributes.profile.course_picked,
        },
      },
    };
  }
  return null;
};

export const TIMETABLE_INELIGIBLE_COUNTRIES = ['in', 'za'];
export const TIMETABLE_INELIGIBLE_DATE_FROM = '2024-01-01';
